import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import * as imageSliderSelector from 'redux/selectors/imageSlider';
import * as imageSliderActions from 'redux/actions/imageSlider';
import { Navbar } from 'components';
import SlideForm from '../Form/slideForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SLIDER_CREATE_SUCCESS } from 'redux/actions/imageSlider/action_types';
import { withEventBus } from 'context/eventbus';

class ImageSlideAdd extends Component {
  constructor(props) {
    super(props);
    this.subscriptions = [];
  }

  componentDidMount() {
    this.subscriptions.push(
      this.props.eventBusSubscribe(SLIDER_CREATE_SUCCESS, action => {
        this.props.history.push(`/options/slides/${action.payload.id}/`);
      })
    );
  }

  submitHandle = formData => {
    this.props.create(formData);
  };

  componentWillUnmount() {
    this.props.unload();
  }

  render() {
    var slide = {
      id: 0,
      version: 0
    };

    return (
      <div>
        <Navbar title={'Create Customer'}>
          <Link type="primary" to={'/options/slides/'}>
            <Tooltip placement="top" title="List Slides">
              <FontAwesomeIcon icon="th-list" />
            </Tooltip>
          </Link>
        </Navbar>
        <div style={{ padding: 16 }}>
          <SlideForm
            key={0}
            submitHandle={this.submitHandle}
            eventBusSubscribe={this.props.eventBusSubscribe}
            data={slide}
          ></SlideForm>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  create: imageSliderActions.create,
  unload: imageSliderActions.unload
};

const mapStateToProps = (state, props) => {
  return {
    slide: imageSliderSelector.get(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withEventBus(ImageSlideAdd));
